import React from "react";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";

const ErrorPage = ({ t }) => {
  return (
    <div className="page-not-found">
      <div>
        <h1>404</h1>
      </div>
      <div className="text-center text-uppercase">
        <p className="mb-0">{t("404.message.error")}</p>
        <p>{t("404.message.apologize")}</p>
        <Link to="/">{t("404.link")}</Link>
      </div>
    </div>
  );
};

export default withNamespaces()(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/PageNotFound.tsx